/*
 * Created on Tue Oct 19 2021
 *
 * Copyright (c) 2021 Khor Chai Hong
 */

// eslint-disable-next-line
import React, { useState, useReducer, useEffect, Suspense } from 'react';
import { Link } from 'react-router-dom';
import { Navigation } from '../Header';
import Loader from './loader';
import { MdKeyboardArrowLeft } from "react-icons/md";
import { Footer } from '../Footer';
import FooterLogo from "../assets/images/icons/footer-logo.png";
import Logo from "../assets/images/icons/big-pink-logo.png";
import SmallLogo from "../assets/images/icons/pink-logo-80.png";
import preloader from "../assets/images/preloaders/12-preloader-10px-d6d6d6.gif";
import { CloseButton } from '../components';
import { useWindowDimensions } from '../utils/helpers';
import Modal from 'react-bootstrap/Modal';

export default function User() {
    document.body.style.background = '#D6D6D6';

    return (
        <div id="user" className="page">
            <div className="position-relative">
                <TopNavPublic />
                <JoinUsModal />
                <Suspense fallback={<Loader otherLoader={preloader} />}>
                    <TempBody />
                </Suspense>
                <div className="footer-wrapper">
                    <img src={FooterLogo} alt="logo" />
                    <Footer displayAll={true} />
                </div>
            </div>
        </div>
    );
}

export function TopNavPublic() {
    return (
        <>
            <Link to={{ pathname: '/login', state: { from: 'user' } }} className="back-to-login">
                <MdKeyboardArrowLeft />
            </Link>
            <Navigation activeTab={false} displayAll={true} isPublic={true} />
        </>
    )
}

export function JoinUsModal({ timeout = 3000, continuousToggling = false, passToggle }) {
    const [showModal, toggleModal] = useReducer(
        showModal => !showModal,
        false
    );

    const [opacity, setOpacity] = useState(1);
    const getOpacity = (opacity) => setOpacity(opacity);
    const { isMobile } = useWindowDimensions();

    useEffect(() => {
        setTimeout(() => { toggleModal() }, timeout);
        // eslint-disable-next-line
    }, [])

    return (
        <Modal
            id="joinUsModal"
            backdropClassName="fa-modal-backdrop"
            dialogClassName="fa-modal-dialog"
            contentClassName="fa-modal-content join-us"
            show={showModal}
            onHide={toggleModal}
        >
            <Modal.Header className="pb-0">
                <img src={!isMobile ? Logo : SmallLogo} alt="Logo" style={{ opacity: opacity }} />
                <CloseButton closeModal={!continuousToggling ? toggleModal : passToggle} passOpacity={getOpacity} />
            </Modal.Header>
            <Modal.Body style={{ opacity: opacity }}>
                <p className="pink-text">Join us, it's free</p>
                {!isMobile ?
                    <p className="join-us-text pn a5-text">
                        In an industry that takes more than giving back, we’re starting by giving <br />
                        creative control back to fashion creatives. No hooks, no catch, <br />
                        it’s absolutely free. So sign up now and let’s all play a part to reshape a <br />
                        more conscious, inclusive and dynamic fashion future.
                    </p>
                    :
                    <p className="join-us-text pn a5-text">
                        In an industry that takes more than giving back,<br />
                        we’re starting by giving creative control back to<br />
                        fashion creatives. No hooks, no catch,<br />
                        it’s absolutely free. So sign up now and let’s all<br />
                        play a part to reshape a more conscious, inclusive<br />
                        and dynamic fashion future.
                    </p>
                }
            </Modal.Body>
            <Modal.Footer className="footer-buttons-div" style={{ opacity: opacity }}>
                <Link to="/signup">
                    <button className="footer-buttons pink-text" onClick={toggleModal}>Create account</button>
                </Link>
                <div className="later pt-1 pn a5-text text-decoration-underline" onClick={!continuousToggling ? toggleModal : passToggle}>Later</div>
            </Modal.Footer>
        </Modal>
    )
}

function TempBody() {
    return (
        <div className="temp-body">

        </div>
    )
}